// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
        Maize, also known as corn, is a highly versatile cereal grain widely cultivated across the world. It is a staple food in many countries and a key raw 
material in several industries. Maize kernels are rich in carbohydrates, essential nutrients, and natural fiber.

      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Appearance: Golden-yellow kernels; available in whole grain, flour, grits, or processed forms</li>
        <li>Taste: Mild, slightly sweet, and earthy flavor</li>
        <li>Texture: Firm when dry; soft and creamy when cooked</li>
        <li>Varieties: Yellow maize, white maize, sweet corn, flint corn, dent corn</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Food Industry: Corn flour, cornmeal, snacks, tortillas, breakfast cereals, popcorn & Sweeteners like corn syrup</li>
        <li>Good source of minerals like magnesium, iron, and phosphorus</li>
        <li>Naturally gluten-free</li>
      </ul>

      <h3>Applications:</h3>
      <ul>
        <li>Food Industry: Corn flour, cornmeal, snacks, tortillas, breakfast cereals, popcorn & Sweeteners like corn syrup</li>
        <li>Animal Feed: A major ingredient in cattle, poultry, and livestock feed</li>
        <li>Industrial Uses: Starch production, biofuel (ethanol), biodegradable plastics, alcohol</li>
        <li>Household Cooking: Used in soups, porridges, bakery products, and traditional dishes</li>

      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Highly adaptable cropSaves time and labor in food preparation</li>
        <li>Long shelf life</li>
        <li>Cost-effective and nutritious</li>
        <li>Used in multiple industries, making it a high-demand commodity</li>

      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
